import { render, staticRenderFns } from "./PastShow.vue?vue&type=template&id=3628b2e4&scoped=true&"
import script from "./PastShow.vue?vue&type=script&lang=js&"
export * from "./PastShow.vue?vue&type=script&lang=js&"
import style0 from "./PastShow.vue?vue&type=style&index=0&id=3628b2e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3628b2e4",
  null
  
)

export default component.exports